const NoData = () => (
  <div>
    <span>Brak danych</span>
  </div>
);

export default NoData;
